export default {
  routes: [
    {
      path: "/",
      name: "Login",
      meta: {
        auth: true,
      },
      component: () => import("@/view/LoginPage"),
    },
    {
      path: "/Header",
      name: "Header",
      component: () => import("@/view/Header"),
      children: [
        {
          path: "/user",
          name: "User",
          component: () => import("@/view/User"),
        },
        {
          path: "/admin",
          name: "Admin",
          component: () => import("@/view/Admin"),
        },
        {
          path: "/banner",
          name: "Banner",
          component: () => import("@/view/Banner"),
        },
        /* 小程序卡券管理 */
        {
          path: "/cardCoupon",
          name: "CardCoupon",
          component: () => import("@/view/cardCouponView/CardCoupon"),
        },
        {
          path: "/cardCouponGoods",
          name: "CardCouponGoods",
          component: () => import("@/view/cardCouponView/CardCouponGoods"),
        },
        {
          path: "/cardCouponAdress",
          name: "CardCouponAdress",
          component: () => import("@/view/cardCouponView/CardCouponAdress"),
        },
        {
          path: "/cardConfig",
          name: "CardConfig",
          component: () => import("@/view/cardCouponView/CardConfig"),
        },
        /* web卡券中心 */
        {
          path: "/webCardCoupon",
          name: "CardCoupon",
          component: () => import("@/view/webCouponView/Goodkinds.vue"),
        },
        {
          path: "/webCardCouponConfig",
          name: "WebCardCouponConfig",
          component: () => import("@/view/webCouponView/pageConfig.vue"),
        },

        {
          path: "/goodkinds",
          name: "Goodkinds",
          component: () => import("@/view/Goodkinds"),
        },
        {
          path: "/goods",
          name: "Goods",
          component: () => import("@/view/Goods"),
        },
        {
          path: "/order",
          name: "Order",
          component: () => import("@/view/Order"),
        },
        {
          path: "/shareToC",
          name: "ShareToC",
          component: () => import("@/view/ShareToC"),
        },
        {
          path: "/shareToB",
          name: "ShareToB",
          component: () => import("@/view/ShareToB"),
        },
        {
          path: "/userMoneyList",
          name: "UserMoneyList",
          component: () => import("@/view/UserMoneyList"),
        },
        {
          path: "/vipCard",
          name: "VipCard",
          component: () => import("@/view/VipCard"),
        },
        {
          path: "/vipCardRecode",
          name: "VipCardRecode",
          component: () => import("@/view/VipCardRecode"),
        },

        {
          path: "/needToC",
          name: "NeedToC",
          component: () => import("@/view/NeedToC"),
        },
        {
          path: "/applyToB",
          name: "ApplyToB",
          component: () => import("@/view/ApplyToB"),
        },
        {
          path: "/tixian",
          name: "Tixian",
          component: () => import("@/view/Tixian"),
        },
        {
          path: "/setpay",
          name: "Setpay",
          component: () => import("@/view/Setpay"),
        },
        {
          path: "/article",
          name: "Article",
          component: () => import("@/view/Article"),
        },
        {
          path: "/store",
          name: "Store",
          component: () => import("@/view/Store"),
        },
        {
          path: "/vipConfig",
          name: "vipConfig",
          component: () => import("@/view/VipConfig"),
        },
        //数据面板
        {
          path: "/DataPanel",
          name: "DataPanel",
          component: () => import("@/view/DataPanel.vue"),
        },
      ],
    },
    {
      path: "*",
      name: "Login",
      meta: {
        auth: true,
      },
      component: () => import("@/view/LoginPage"),
    },
  ],
  // mode: "history",
  mode: "hash",
};
